// extracted by mini-css-extract-plugin
export default {"fullscreen":"Pf_eRa3G8nV0Yq888_Pq","zoom":"XXUlK9ncO0wRy2PC5IG1","zoomOut":"uKp9GNVtjWYPLl9VBlXA"};